const profile = {
    name: 'Имя',
    avatar: 'Аватар',
    givenName: 'Имя',
    familyName: 'Фамилия',
    middleName: 'Отчество',
    fullname: 'Полное имя',
    nickname: 'Никнейм',
    preferredUsername: 'Предпочитаемое имя пользователя',
    profile: 'Профиль',
    website: 'Веб-сайт',
    gender: 'Пол',
    birthdate: 'Дата рождения',
    zoneinfo: 'Часовой пояс',
    locale: 'Язык',
    address: {
        formatted: 'Адрес',
        streetAddress: 'Улица',
        locality: 'Город',
        region: 'Штат/Область',
        postalCode: 'Почтовый индекс',
        country: 'Страна',
    },
    gender_options: {
        female: 'Женский',
        male: 'Мужской',
        prefer_not_to_say: 'Предпочитаю не говорить',
    },
    checkbox_value: {
        checked: 'Да',
        unchecked: 'Нет',
    },
    avatar_upload: {
        upload: 'Загрузить',
        remove: 'Удалить',
        uploading: 'Загрузка...',
        hint: 'Рекомендуемый размер 1:1, до {{limit}}.',
        error_file_type: 'Тип файла должен быть {{extensions}}.',
        error_file_size: 'Размер файла не должен превышать {{limit}}.',
        error_storage_not_configured: 'Не удалось загрузить фото. Повторите попытку позже.',
        error_upload: 'Не удалось загрузить фото. Попробуйте ещё раз.',
        error_save: 'Не удалось сохранить фото. Повторите попытку.',
        crop_title: 'Обрезать фото',
        zoom: 'Масштаб',
        error_crop: 'Не удалось обрезать изображение. Попробуйте ещё раз.',
    },
};
export default Object.freeze(profile);
